import { render, staticRenderFns } from "./NewsFAQ.vue?vue&type=template&id=352a0750&scoped=true"
import script from "./NewsFAQ.vue?vue&type=script&lang=js"
export * from "./NewsFAQ.vue?vue&type=script&lang=js"
import style0 from "./NewsFAQ.vue?vue&type=style&index=0&id=352a0750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352a0750",
  null
  
)

export default component.exports